module.exports = __webpack_public_path__ + "static/media/fi-rr-credit-card-white-outline.2a5c7555.svg";